const { initUiLangSwitcher } = require("./lib/i18n");
const { initViewerMenuButton } = require("./lib/viewer_menu");

initViewerMenuButton();
initUiLangSwitcher();